import { render, staticRenderFns } from "./Acompanhar.vue?vue&type=template&id=45c2653a"
import script from "./Acompanhar.vue?vue&type=script&lang=js"
export * from "./Acompanhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports